import React from 'react';
import FormPage from '../../../../../../common/DealApplicationDrawer/Components/Page/FormPage';
import { DealTermsLogType as DealTermsLogType } from '../DealTermsLoggingDrawer/DealTermsLoggingDrawer';
import styles from './DealTermsLog.module.scss';
import { useAppSelector } from '../../../../../../app/hooks';

interface DealTermsLogProps {
    formData: DealTermsLogType & { currentLogId?: string };
    dealTermsLoggingConfig: any;
    setIsFormValid: (isValid: boolean) => void;
    onUpdateLog: (updatedLog: DealTermsLogType) => void;
    logPositionMap: Map<string, { logDate: string; logPosition: number }>;
}

export const DealTermsLog: React.FC<DealTermsLogProps> = ({
    formData,
    dealTermsLoggingConfig,
    setIsFormValid,
    onUpdateLog,
    logPositionMap,
}) => {
    const userName = useAppSelector((state) => state.user.userData.userName);

    const updateDealLogs = (key: string, value: string | string[]) => {
        if (key === 'logDate') {
            const updatedLog = {
                ...formData,
                logDate: Array.isArray(value) ? value[0] : value,
                dealTerms: {
                    ...formData.dealTerms,
                    [key]: Array.isArray(value) ? value[0] : value,
                },
            };
            onUpdateLog(updatedLog);
            return;
        }

        const updatedLog = {
            ...formData,
            dealTerms: {
                ...formData.dealTerms,
                [key]: value,
            },
        };
        onUpdateLog(updatedLog);
    };

    return (
        <div className={styles.logContainer}>
            <FormPage
                step={0}
                setIsFormValid={setIsFormValid}
                page={dealTermsLoggingConfig?.mainConfig?.additionalDetailsConfig?.pages[0]?.config}
                formData={formData}
                updateDealLogs={updateDealLogs}
                logPositionMap={logPositionMap}
                currentLogId={formData.currentLogId}
            />
        </div>
    );
};

export default DealTermsLog;
